// DOM → PDF export, single tall page. Same mechanism as the MyJarvis dashboard:
// render the element to a high-DPI canvas via html-to-image (pixelRatio 2 for
// crisp text), then drop the whole canvas onto ONE PDF page sized to fit the
// full content height. jspdf + html-to-image are imported DYNAMICALLY so they
// code-split into their own chunk — the public funnel bundle is unaffected.
export async function downloadAsPdf(element: HTMLElement, filename: string) {
  const [{ toCanvas }, { default: jsPDF }] = await Promise.all([
    import("html-to-image"),
    import("jspdf"),
  ])

  await document.fonts.ready

  const fullCanvas = await toCanvas(element, {
    pixelRatio: 2,
    cacheBust: true,
    backgroundColor: "#FFFFFF",
  })
  const fullW = fullCanvas.width
  const fullH = fullCanvas.height

  const PAGE_W = 210 // A4 width, mm
  const MARGIN = 12
  const printableW = PAGE_W - MARGIN * 2

  const canvasPxPerMm = fullW / printableW
  const contentHeightMm = fullH / canvasPxPerMm
  const pageHeightMm = contentHeightMm + MARGIN * 2

  const pdf = new jsPDF({
    orientation: "portrait",
    unit: "mm",
    format: [PAGE_W, pageHeightMm],
    compress: true,
  })

  const dataUrl = fullCanvas.toDataURL("image/png")
  pdf.addImage(dataUrl, "PNG", MARGIN, MARGIN, printableW, contentHeightMm, undefined, "FAST")
  pdf.save(filename.endsWith(".pdf") ? filename : `${filename}.pdf`)
}
